// Strip markdown and emoji so TTS reads naturally — i sintetizzatori altrimenti
// pronunciano "✅" come "segno di spunta verde", "📝" come "memo", ecc.
// Belt-and-suspenders: copriamo Extended_Pictographic + range espliciti dei
// principali blocchi emoji + variation selectors + ZWJ + bullets vari. Nessun
// singolo escape unicode è garantito di matchare tutto in tutti i runtime.
export function sanitizeForTTS(text) {
  return text
    .replace(/\*\*/g, '')
    .replace(/\*/g, '')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^[-•·▪▫►◆◇■□◉]\s+/gm, '')
    .replace(/^\d+\.\s+/gm, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/~~([^~]+)~~/g, '$1')
    // Emoji + simboli pittografici
    .replace(/\p{Extended_Pictographic}/gu, '')
    .replace(/[\u{1F300}-\u{1FAFF}]/gu, '')
    .replace(/[\u{2600}-\u{27BF}]/gu, '')
    .replace(/[\u{1F000}-\u{1F2FF}]/gu, '')
    .replace(/[\u{1F1E6}-\u{1F1FF}]/gu, '')
    // Variation selectors (es. ️ dopo 🗑) + ZWJ
    .replace(/[\u{FE00}-\u{FE0F}\u{200D}]/gu, '')
    // Compattazione spazi residui
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/\n{2,}/g, '. ')
    .replace(/\n/g, ', ')
    .replace(/\s+([,.;:!?])/g, '$1')
    .trim()
}

// Speak using Web Speech API synthesizer. onEnd fires after utterance completes.
export function speakWithSynth(synth, text, lang, onEnd) {
  if (!synth) { onEnd?.(); return }
  synth.cancel()

  const utterance = new SpeechSynthesisUtterance(sanitizeForTTS(text))
  utterance.lang = lang === 'it' ? 'it-IT' : 'en-US'
  utterance.rate = 1.0
  utterance.pitch = 1.0

  const voices = synth.getVoices()
  const langCode = lang === 'it' ? 'it' : 'en'
  const preferred = voices.find(v => v.lang.startsWith(langCode) && v.name.includes('Google'))
    || voices.find(v => v.lang.startsWith(langCode))
  if (preferred) utterance.voice = preferred

  if (onEnd) utterance.onend = onEnd
  synth.speak(utterance)
}
